// *************************************************
// ************* Section Scroll Reveal *************
// *************************************************

import hunt from 'huntjs';
import { siteSettings } from '../../js/global';

import './section-scroll-reveal.scss';

class ScrollSection {

    constructor(el) {
        if(siteSettings.reducedMotionPref) {
            el.classList.remove('section-scroll-reveal');
        } else {
            this.el = el;
            this.items = [];
            this.delayIncrement = 250;
            this.negIncrement = 0 - this.delayIncrement;
            this.revealDelay = this.negIncrement;
            // get reveal-items in this section
            let find = this.el.querySelectorAll('.section--scroll-reveal--item');
            find.forEach((r,i) => {
                this.items[i] =  {
                    obj: r,
                    revealTimeout: null,
                    revealed: false
                }
                // watch with hunt
                let huntConfig = {
                    enter: () => {
                        if(!this.items[i].revealed && !this.items[i].revealTimeout) {
                            this.updateDelay(true);
                            this.items[i].revealTimeout = setTimeout(() => {
                                this.itemReveal(i);
                            }, this.revealDelay);
                        }
                    }
                };
                this.items[i].hunt = new hunt(r, huntConfig);
            });
            // add hunt to this section
            let _this = this;
            this.hunt = new hunt(this.el, {
                enter: function () {
                    _this.sectionReveal();
                }
            });
        }
    }
    
    updateDelay(mode) {
        this.revealDelay += (mode ? this.delayIncrement : this.negIncrement); // half second gaps between reveals
        if(this.revealDelay < this.negIncrement) this.revealDelay = this.negIncrement;
    }

    sectionReveal() {
        this.el.classList.add('section-reveal');
    }

    itemReveal(i) {
        this.items[i].revealed = true;
        this.items[i].obj.classList.add('item-reveal');
        this.updateDelay(false);
    }

}

// export the default function to create
export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new ScrollSection(node);
        }
    });
}